<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Configuration des canaux</h1>
        <p class="text-subtitle-1 text-grey mb-6">
          Configurez les canaux de communication (email, SMS, etc.)
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Canaux de communication</v-card-title>
          <v-card-text>
            <p>Configuration des canaux de communication à implémenter.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
// Placeholder for channels settings
</script>
